<div class="app-loading" *ngIf="isLoading$ | async" aria-label="Chargement">
  <div class="spinner"></div>
</div>

<app-login *ngIf="!(isLoading$ | async) && !isAuthenticated"></app-login>
<label class="language-picker language-picker--login" *ngIf="!(isLoading$ | async) && !isAuthenticated">
  <span class="sr-only">Langue / Language</span>
  <select [value]="language.currentLanguage()" (change)="language.setLanguage($any($event.target).value)" aria-label="Langue / Language">
    <option *ngFor="let item of language.languages()" [value]="item.name">{{ item.nativeName }}</option>
  </select>
</label>

<div class="app-layout" *ngIf="!(isLoading$ | async) && isAuthenticated">
  <div class="navigation-loading" *ngIf="isNavigating()" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <span>Chargement de la page…</span>
  </div>

  <nav class="main-nav" role="navigation" aria-label="Navigation principale">
    <div class="nav-brand">
      <img class="rio-logo" src="images/Rio-Tinto-Symbol.png" alt="Rio Tinto">
      <span class="brand-copy">
        <strong>Index des livrables</strong>
        <small>GOUVERNANCE DE PROJETS</small>
      </span>
    </div>

    <ul class="nav-links" role="list">
      <li>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          (click)="closeProject()">
          <span class="nav-icon" aria-hidden="true">⌂</span> Portefeuille
        </a>
      </li>
      <li>
        <a routerLink="/reports" routerLinkActive="active">
          <span class="nav-icon" aria-hidden="true">▤</span> Rapports
        </a>
      </li>
    </ul>

    <p class="nav-section">ADMINISTRATION</p>
    <ul class="nav-links admin-links" role="list">
      <li>
        <a routerLink="/settings" routerLinkActive="active">
          <span class="nav-icon" aria-hidden="true">⚙</span> Paramètres
        </a>
      </li>
    </ul>

    <div class="nav-footer">
      <a class="user-avatar" routerLink="/profile" aria-label="Ouvrir mon profil">{{ userInitials() }}</a>
      <button class="logout-btn" (click)="logout()" aria-label="Se déconnecter" title="Se déconnecter">↪</button>
    </div>
  </nav>

  <div class="app-shell">
    <header class="topbar">
      <span class="topbar-spacer"></span>
      <label class="language-picker">
        <span class="sr-only">Langue / Language</span>
        <select [value]="language.currentLanguage()" (change)="language.setLanguage($any($event.target).value)" aria-label="Langue / Language">
          <option *ngFor="let item of language.languages()" [value]="item.name">{{ item.nativeName }}</option>
        </select>
      </label>
      <span class="topbar-context">OPÉRATIONS QUÉBEC</span>
      <button type="button" class="help-link" (click)="openHelp()" aria-haspopup="dialog" [attr.aria-expanded]="helpOpen()"><span aria-hidden="true">?</span> Aide</button>
      <button class="topbar-icon" aria-label="Options">◊</button>
    </header>

    <main class="main-content" role="main">
      <app-project-detail
        *ngIf="selectedProject()"
        [project]="selectedProject()!"
        (back)="closeProject()"
        (projectUpdated)="onProjectUpdated($event)">
      </app-project-detail>

      <ng-container *ngIf="!selectedProject()">
        <router-outlet></router-outlet>
      </ng-container>
    </main>
  </div>

  <div class="help-backdrop" *ngIf="helpOpen()" (click)="closeHelp()">
    <section class="help-dialog" role="dialog" aria-modal="true" aria-labelledby="help-title" (click)="$event.stopPropagation()">
      <header>
        <h2 id="help-title">{{ help().title }}</h2>
        <button type="button" class="help-close" (click)="closeHelp()" aria-label="Fermer l’aide">×</button>
      </header>
      <p>{{ help().description }}</p>
      <ul>
        <li *ngFor="let item of help().items">{{ item }}</li>
      </ul>
      <button type="button" class="btn-primary" (click)="closeHelp()">Fermer</button>
    </section>
  </div>
</div>
